import React, { memo } from "react"
import { CMS_ELEMENT_TYPENAME } from "@repo/utils/constants"
import { TYPES as COMMON_TYPES } from "@repo/ui/lib"
import dynamicWithLoader from "@repo/ui/src/components/common/DynamicWithLoader"
import { getMapKey } from "@repo/utils"
import VideoBanner from "@repo/ui/src/components/Banners/VideoBanner"
import TextModules from "@repo/ui/src/components/textModules/TextModules" // jeżeli jest import dynamiczny to jest bug ze zmianą tła

const DynamicDescriptionSlogan = dynamicWithLoader(() => import("@repo/ui/src/components/common/DescriptionSlogan"))
const DynamicSingleAsset = dynamicWithLoader(() => import("@repo/ui/src/components/common/SingleAsset"))
const DynamicNewsThumbnails = dynamicWithLoader(() => import("@repo/ui/src/components/newsThumbnails/NewsThumbnails"))
const DynamicDescriptionLinePleo = dynamicWithLoader(() => import("@repo/ui/src/components/DescriptionLinePleo"))
const DynamicHowWeCreateStory = dynamicWithLoader(() => import("@repo/ui/src/components/HowWeCreateStory"))
const DynamicBlobSlogan = dynamicWithLoader(() => import("@repo/ui/src/components/BlobSlogan/index"))
const DynamicFeaturedProjects = dynamicWithLoader(() => import("@repo/ui/src/components/FeaturedProjects"))
const DynamicWhoWeWorkedWith = dynamicWithLoader(() => import("@repo/ui/src/components/WhoWeWorkedWith"))
const DynamicHorizontalHeaderModule = dynamicWithLoader(() => import("@repo/ui/src/components/common/HorizontalHeaderModule"))
const DynamicSocialMedia = dynamicWithLoader(() => import("@repo/ui/src/components/SocialMedia/SocialMedia"))
const DynamicCheckOthers = dynamicWithLoader(() => import("@repo/ui/src/components/CheckOthers"))
const DynamicPleoContext = dynamicWithLoader(() => import("@repo/ui/src/components/PleoContext"))
const DynamicPleoBranches = dynamicWithLoader(() => import("@repo/ui/src/components/PleoBranches"))
const DynamicContactForm = dynamicWithLoader(() => import("@repo/ui/src/components/ContactForm"))
const DynamicQuickContact = dynamicWithLoader(() => import("@repo/ui/src/components/QuickContact/QuickContact"))
const DynamicFAQ = dynamicWithLoader(() => import("@repo/ui/src/components/FAQ/FAQ"))
const DynamicProjectRange = dynamicWithLoader(() => import("@repo/ui/src/components/projectRange/ProjectRange"))
const DynamicTiles = dynamicWithLoader(() => import("@repo/ui/src/components/Tiles"))
const DynamicHeaderAndDescription = dynamicWithLoader(() => import("@repo/ui/src/components/common/HeaderAndDescription"))
const DynamicProjectScope = dynamicWithLoader(() => import("@repo/ui/src/components/projectScope/ProjectScope"))
const DynamicStyledGallery = dynamicWithLoader(() => import("@repo/ui/src/components/common/StyledGallery"))
const DynamicPinnedTextWithImage = dynamicWithLoader(() => import("@repo/ui/src/components/PinnedTextWithImage/PinnedTextWithImage"))
const DynamicAssetWithHeaderAndDescription = dynamicWithLoader(() => import("@repo/ui/src/components/common/AssetWithHeaderAndDescription"))
const DynamicProjectSlider = dynamicWithLoader(() => import("@repo/ui/src/components/projectSlider/ProjectSlider"))
const DynamicProjectTechnologiesTable = dynamicWithLoader(
	() => import("@repo/ui/src/components/common/projectTechnologiesTable/ProjectTechnologiesTable"),
)
const DynamicAreasOfExpertise = dynamicWithLoader(() => import("@repo/ui/src/components/AreasOfExpertise"))
const DynamicBenefitsModule = dynamicWithLoader(() => import("@repo/ui/src/components/BenefitsModule"))
const DynamicTechnologiesTiles = dynamicWithLoader(() => import("@repo/ui/src/components/TechnologiesTiles"))
const DynamicNumbersModule = dynamicWithLoader(() => import("@repo/ui/src/components/NumbersModule"))
const DynamicClientsAboutUs = dynamicWithLoader(() => import("@repo/ui/src/components/ClientsAboutUs"))
const DynamicCheckOtherServices = dynamicWithLoader(() => import("@repo/ui/src/components/checkOtherServices/CheckOtherServices"))
const DynamicTilesWithDescription = dynamicWithLoader(() => import("@repo/ui/src/components/TilesWithDescription"))
const DynamicHowWeWorkModule = dynamicWithLoader(() => import("@repo/ui/src/components/HowWeWorkModule"))
const DynamicServicesCards = dynamicWithLoader(() => import("@repo/ui/src/components/ServicesCards"))
const DynamicProjectsGridWrapper = dynamicWithLoader(() => import("@repo/ui/src/components/ProjectsGridWrapper"))
const DynamicProductsGrid = dynamicWithLoader(() => import("@repo/ui/src/components/productsGrid/ProductsGrid"))
const DynamicHeaderDescriptionButtonBanner = dynamicWithLoader(
	() => import("@repo/ui/src/components/Banners/HeaderDescriptionButtonBanner"),
)
const DynamicCareerModule = dynamicWithLoader(() => import("@repo/ui/src/components/CareerModule"))
const DynamicJobOfferForm = dynamicWithLoader(() => import("@repo/ui/src/components/JobOfferForm"))
const DynamicStoryModule = dynamicWithLoader(() => import("@repo/ui/src/components/Story"))
const DynamicSectionHeader = dynamicWithLoader(() => import("@repo/ui/src/components/sectionHeader/SectionHeader"))
const DynamicAboutTeamDesign = dynamicWithLoader(() => import("@/components/AboutTeam"))

const Component = ({ item, typename, hidePleoTags, isSinglePage, isServicePage, index, locale, storyData, bgColor, textColor }) => {
	switch (typename) {
		case COMMON_TYPES.VIDEO_BANNER:
			return <VideoBanner data={item} locale={locale} webGL />
		case COMMON_TYPES.DESCRIPTION_SLOGAN:
			return <DynamicDescriptionSlogan data={item} />
		case COMMON_TYPES.SINGLE_ASSET:
			return <DynamicSingleAsset key={item?.id || index} data={item} index={index} />
		case COMMON_TYPES.ASSET_WITH_HEADER:
			return <DynamicAssetWithHeaderAndDescription key={item?.id || index} data={item} />
		case COMMON_TYPES.HEADER_AND_DESCRIPTION:
			return <DynamicHeaderAndDescription key={item?.id || index} id={item} data={item} />
		case COMMON_TYPES.ASSETS_GALLERY:
			return <DynamicStyledGallery key={item?.id || index} data={item} />
		case COMMON_TYPES.PROJECT_SECTION_HEADER:
			return <DynamicSectionHeader key={item?.id || index} data={item} />
		case COMMON_TYPES.PROJECT_RANGE:
			return (
				<DynamicProjectRange
					key={item?.id || index}
					data={item}
					index={index}
					locale={locale}
					bgColor={bgColor}
					textColor={textColor}
				/>
			)
		case COMMON_TYPES.PROJECT_SCOPE:
			return <DynamicProjectScope key={item?.id || index} data={item} locale={locale} />
		case COMMON_TYPES.TEXT_MODULE:
			return <TextModules key={item.id || index} data={item} locale={locale} isServicePage={isServicePage} />
		case COMMON_TYPES.PINNED_TEXT_WITH_IMAGE:
			return <DynamicPinnedTextWithImage key={item?.id || index} data={item} locale={locale} />
		case COMMON_TYPES.PROJECT_SLIDER:
			return <DynamicProjectSlider key={item?.id || index} data={item} locale={locale} />
		case COMMON_TYPES.TECHNOLOGIES_TABLE:
			return <DynamicProjectTechnologiesTable key={item?.id || index} data={item} locale={locale} />
		case COMMON_TYPES.CHECK_OTHERS:
			return <DynamicCheckOthers data={item} />
		case COMMON_TYPES.FORM:
			return <DynamicContactForm data={item} locale={locale} />
		case COMMON_TYPES.PLEO_CONTEXT:
			return <DynamicPleoContext data={item} />
		case COMMON_TYPES.PLEO_BRANCHES:
			return <DynamicPleoBranches data={item} />
		case COMMON_TYPES.WHO_WE_WORKED_WITH:
			return <DynamicWhoWeWorkedWith data={item} />
		case COMMON_TYPES.HORIZONTAL_HEADER:
			return <DynamicHorizontalHeaderModule key={item?.id} data={item} />
		case COMMON_TYPES.QUICK_CONTACT:
			return <DynamicQuickContact data={item} />
		case COMMON_TYPES.PRODUCTS_GRID:
			return <DynamicProductsGrid data={item} />
		case COMMON_TYPES.ABOUT_TEAM:
			return <DynamicAboutTeamDesign data={item} />
		case COMMON_TYPES.DESCRIPTION_LOGO_PLEO:
			return <DynamicDescriptionLinePleo data={item} />
		case COMMON_TYPES.COMMON_BLOB_SLOGAN:
			return <DynamicBlobSlogan data={item} />
		case COMMON_TYPES.FEATURED_PROJECTS:
			return <DynamicFeaturedProjects data={item} type="design" />
		case COMMON_TYPES.NEWS_THUMBNAILS:
			return <DynamicNewsThumbnails data={item} hidePleoTags={hidePleoTags} />
		case COMMON_TYPES.HOW_WE_CREATE_STORY:
			return <DynamicHowWeCreateStory data={item} isSinglePage={isSinglePage} />
		case COMMON_TYPES.SERVICES_CARDS:
			return <DynamicServicesCards data={item} />
		case COMMON_TYPES.HOW_WE_WORK_MODULE:
			return <DynamicHowWeWorkModule data={item} />
		case COMMON_TYPES.TILES_WITH_DESCRIPTION:
			return <DynamicTilesWithDescription data={item} />
		case COMMON_TYPES.AREAS_OF_EXPERTISE:
			return <DynamicAreasOfExpertise data={item} />
		case COMMON_TYPES.TILES_MODULE:
			return <DynamicTiles data={item} />
		case COMMON_TYPES.SOCIAL_MEDIA:
			return <DynamicSocialMedia data={item} />
		case COMMON_TYPES.CHECK_OTHER_SERVICES:
			return <DynamicCheckOtherServices data={item} />
		case COMMON_TYPES.TECHNOLOGIES_TILES:
			return <DynamicTechnologiesTiles data={item} />
		case COMMON_TYPES.BENEFITS_MODULE:
			return <DynamicBenefitsModule data={item} />
		case COMMON_TYPES.CLIENTS_ABOUT_US_RECORD:
			return <DynamicClientsAboutUs data={item} />
		case COMMON_TYPES.NUMBERS_RECORD:
			return <DynamicNumbersModule data={item} />
		case COMMON_TYPES.PROJECTS_GRID:
			return <DynamicProjectsGridWrapper data={item} type="design" />
		case COMMON_TYPES.CAREER_MODULE:
			return <DynamicCareerModule data={item} />
		case COMMON_TYPES.JOB_OFFER_FORM:
			return <DynamicJobOfferForm data={item} />
		case COMMON_TYPES.FAQ:
			return <DynamicFAQ data={item} />
		case COMMON_TYPES.HEADER_DESCRIPTION_BUTTON_BANNER_RECORD:
			return <DynamicHeaderDescriptionButtonBanner data={item} type="design" />
		case COMMON_TYPES.STORY_MODULE:
			return <DynamicStoryModule data={item} items={storyData} />
		default:
			return null
	}
}

const ExtendedContent = ({ content, locale, isServicePage, hidePleoTags, isSinglePage, storyData }) => {
	if (!Array.isArray(content)) return

	return content.map((item, index) => (
		<Component
			key={getMapKey(item, index)}
			item={item}
			typename={item[CMS_ELEMENT_TYPENAME]}
			index={index}
			locale={locale}
			isServicePage={isServicePage}
			hidePleoTags={hidePleoTags}
			isSinglePage={isSinglePage}
			storyData={storyData}
		/>
	))
}

export default memo(ExtendedContent)
